module.exports = __webpack_public_path__ + "img/introduce_content_5_ug.a259527a.png";